import * as Sentry from "@sentry/react";

// Initialise Sentry for the browser app. Graceful no-op unless
// VITE_SENTRY_DSN_WEB is set at build time, so dev builds and production builds
// made before the Config Vars are added are unaffected.
//
// Session replay is intentionally NOT enabled in this version.
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN_WEB;
  if (!dsn) {
    // eslint-disable-next-line no-console
    console.log("[Sentry] DSN not configured, Sentry disabled");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],

    // Performance monitoring — sample lightly in production.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Release tracking — VITE_APP_VERSION is injected from version.ts at build.
    release: import.meta.env.VITE_APP_VERSION || "unknown",
    environment: import.meta.env.PROD ? "production" : "development",

    // Drop aborted/cancelled requests — they're noise, not bugs.
    beforeSend(event, hint) {
      const err = hint.originalException;
      if (err instanceof Error && err.message.includes("aborted")) {
        return null;
      }
      return event;
    },
  });

  // eslint-disable-next-line no-console
  console.log("[Sentry] Initialized for environment:", import.meta.env.MODE);
}
